import React from "react";
import "../styling/Experience.css";
import LuLogo from "../assets/lu.webp";
import AspireLogo from "../assets/aspire_software.webp";
import DigitshomeLogo from "../assets/digits-home.webp";
import FreeLanceLogo from "../assets/freelance.webp";

const experiences = [
  {
  "title": "IT and Software Department",
  "date": "Oct 2024 – Present",
  "company": "Digits Home",
  "description": "Provide IT services and technical support with a focus on networking (GPON, switching, fiber optics) and system setup (CCTV, VoIP, nurse call, parking systems, GSM), including leading installations, software configuration, and diagnostics.",
  "logo": DigitshomeLogo
}

,
  {
  "title": "Full Stack Internship",
  "date": "Aug 2024 – Sep 2024",
  "company": "Aspire Software",
  "description": "Designed and developed websites using Node.js, Express.js, and MongoDB.",
  "logo": AspireLogo
}
,
  {
    title: "Freelance Developer",
    date: "Feb 2022 – Present",
    company: "",
    description:
      "One-time paid tasks and projects related to software development.",
    logo: FreeLanceLogo,
  },
];

const Experience = () => {
  return (
    <div id="experience-section" className="experience">
      <div className="experience-header">
        <h5>Resume</h5>
        <h1>More of my credentials</h1>
        <p>Work Experience</p>
      </div>
      <div className="timeline">
        {experiences.map((item, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-left">
              <h3>{item.title}</h3>
              <span>{item.date}</span>
            </div>

            <div className="timeline-logo">
              <img src={item.logo} alt={`${item.company} logo`} />
            </div>

            <div className="timeline-right">
              <h4>{item.company}</h4>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="experience-header">
        <p>Education</p>
      </div>
      <div className="timeline">
        <div className="timeline-item">
          <div className="timeline-left">
            <h3>Bachelor's Degree</h3>
            <span>Oct 2020 - July 2024</span>
          </div>

          <div className="timeline-logo">
            <img src={LuLogo} alt={`Lebanese University`} />
          </div>

          <div className="timeline-right">
            <h4>Lebanese University</h4>
            <p>Computer Science - Faculty of Sciences.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
